import SimpleTooltip from "@rio-cloud/rio-uikit/SimpleTooltip";
import moment from "moment";

import { useT } from "@hooks";

export type KpiTooltipPlacement = "bottom-start" | "bottom-end";

export const formatPeriodRange = (startDate?: string, endDate?: string): string | null => {
  const start = moment(startDate ?? "", "YYYY-MM-DD", true);
  const end = moment(endDate ?? "", "YYYY-MM-DD", true);

  if (!start.isValid() || !end.isValid()) return null;

  return start.isSame(end, "month")
    ? `${start.format("DD")}-${end.format("DD/MM/YYYY")}`
    : `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`;
};

interface KpiTooltipContentProps {
  title: string;
  description: string;
  lines: string[];
  periodRange: string | null;
}

const KpiTooltipContent = ({ title, description, lines, periodRange }: KpiTooltipContentProps) => {
  const t = useT();

  return (
    <div className="display-flex flex-column gap-10">
      <span className="text-medium">{title}</span>
      <span>{description}</span>
      <div className="bg-darker text-color-white rounded padding-5 padding-x-10 display-flex flex-column">
        {lines.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </div>
      {periodRange && <span>{t("dashboard.kpi.tooltip.period", { range: periodRange })}</span>}
    </div>
  );
};

interface KpiInfoTooltipProps extends KpiTooltipContentProps {
  placement?: KpiTooltipPlacement;
}

const KpiInfoTooltip = ({ placement = "bottom-start", ...content }: KpiInfoTooltipProps) => (
  <SimpleTooltip
    content={<KpiTooltipContent {...content} />}
    placement={placement}
    width={250}
    textAlignment="left"
    innerClassName="bg-darkest text-color-white kpi-tooltip"
  >
    <span className="rioglyph rioglyph-info-sign margin-left-5 cursor-pointer" aria-hidden="true" />
  </SimpleTooltip>
);

export default KpiInfoTooltip;
